<h1 mat-dialog-title>
  @if (isEditing) {
    Edit Timesheet Description
  } @else {
    Create A New Timesheet
  }

  @if (record) {
    <div class="text-base">
      which will include
      @if (!isQuantity && !isText) {
        <strong>{{ record.Catshours }} hours</strong>
      } @else if (isQuantity) {
        <strong>{{ record.Quantity }} quantity</strong>
      } @else if (isText) {
        <strong>{{ textDisplayName }}</strong> text for <strong>{{ textDisplayDay }}</strong>
      }
      @if (activityName !== '') {
        for <strong>{{ activityName ?? 'this activity' }}</strong>
      }
    </div>
  }
  @if (productionGroup) {
    <div class="text-base">which will include all the records on this Production Group</div>
  }
</h1>

<mat-dialog-content class="w-[750px]">
  <mat-form-field class="mb-4 w-full">
    <mat-label>Description</mat-label>
    <input type="text" matInput [formControl]="descriptionCtrl" (blur)="trimWhitespace()" />
    <mat-hint
      >This should be at least {{ descriptionMinLength }} characters long, and different than other timesheet
      descriptions</mat-hint
    >
    @if (descriptionCtrl.hasError('required')) {
      <mat-error>This description cannot be blank</mat-error>
    }
    @if (descriptionCtrl.hasError('minlengthNoWhitespace')) {
      <mat-error>This description needs to be at least {{ descriptionMinLength }} characters long </mat-error>
    }
    @if (descriptionCtrl.hasError('duplicateDescription')) {
      <mat-error
        >This description is the same as timesheet #{{ duplicateTimesheetNumber }} in your current view of
        {{ selectedCostCenterCondGrpTabs.custGroup }}-{{ selectedCostCenterCondGrpTabs.costCenter }}
      </mat-error>
    }
  </mat-form-field>

  @if (headersList.length > 0) {
    <div class="grid grid-cols-2 gap-4">
      @for (header of headersList; track header) {
        <grid-switch
          [config]="header.config"
          [formLabel]="header.config.header"
          [value]="header.selectedValue"
          (valueChanged)="handleHeaderSelectionChange(header, $event)"
        />
      }
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions>
  @if (isEditing) {
    <button mat-raised-button color="primary" [disabled]="descriptionCtrl.invalid" (click)="handleSubmitClicked()">
      Save Changes
    </button>
  } @else {
    @if (record) {
      <button mat-raised-button color="primary" [disabled]="descriptionCtrl.invalid" (click)="handleSubmitClicked()">
        <mat-icon svgIcon="move-time" />
        Create Timesheet &amp; Move Record
      </button>
    } @else if (productionGroup) {
      <button mat-raised-button color="primary" [disabled]="descriptionCtrl.invalid" (click)="handleSubmitClicked()">
        <mat-icon svgIcon="move-time" />
        Create Timesheet &amp; Move Production Group Records
      </button>
    } @else {
      <button mat-raised-button color="primary" [disabled]="descriptionCtrl.invalid" (click)="handleSubmitClicked()">
        <mat-icon>add</mat-icon>
        Create Timesheet
      </button>
    }
  }
</mat-dialog-actions>
